
import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import * as z from "zod";

const cancelFormSchema = z.object({
  reason: z.string().min(3, {
    message: "A justificativa deve ter pelo menos 3 caracteres",
  }),
});

type CancelFormValues = z.infer<typeof cancelFormSchema>;

interface TableCancelDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  tableId: string;
  onConfirm: (tableId: string, reason: string) => void;
}

const TableCancelDialog: React.FC<TableCancelDialogProps> = ({
  open,
  onOpenChange,
  tableId,
  onConfirm,
}) => {
  const form = useForm<CancelFormValues>({
    resolver: zodResolver(cancelFormSchema),
    defaultValues: {
      reason: "",
    },
  });

  const handleSubmit = (values: CancelFormValues) => {
    onConfirm(tableId, values.reason);
    form.reset();
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Cancelar Mesa</DialogTitle>
          <DialogDescription>
            Informe o motivo do cancelamento da mesa. O número desta mesa ficará disponível para reuso.
          </DialogDescription>
        </DialogHeader>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(handleSubmit)} className="space-y-4">
            <FormField
              control={form.control}
              name="reason"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Motivo do cancelamento</FormLabel>
                  <FormControl>
                    <Textarea 
                      placeholder="Informe o motivo do cancelamento..." 
                      className="resize-none" 
                      {...field} 
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <DialogFooter>
              <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
                Cancelar
              </Button>
              <Button type="submit" variant="destructive">
                Confirmar Cancelamento
              </Button>
            </DialogFooter>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
};

export default TableCancelDialog;
